export enum EAccessType {
    ConfirmResetPassword = 0,
    TFA = 1,
    FAT = 2,
    NONE = 4, // Note: the NONE access type does not exist on the backend, and it is only here to describe none authenticated users.
}
